//#region imports
import customAxios from '../../utils/customAxios';
import { formatDateDDMMYYYY } from '../../utils/dateFormat';
import React, { useState, useEffect } from 'react';

import { DataGridPro, GridToolbar } from '@mui/x-data-grid-pro';

import ModalTDelete from '../Modal/Delete/ModalTDelete';
import { useNavigate } from 'react-router-dom';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { useTableLocale } from '../../hooks/useTableLocale';

import { Stack } from '@mui/system';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAdd,
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble,
} from '@fortawesome/free-solid-svg-icons';

import { DeleteOutlineOutlined as DeleteIcon } from '@mui/icons-material';

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';

import ModalTUpdate from '../Modal/Update/ModalTUpdate';
import ModalTMultDelete from '../Modal/Delete/Multiple/ModalTMultDelete';
import { useTranslationHook } from '../../hooks/UseTranslationHook';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import ModalT from '../Modal/Create/ModalT';
import { GlobalVariables } from '../../globalVar';
import { useTour } from '@reactour/tour';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import useTechsTour from '../../tours/techsTour';
import { useUserPermissions } from '../../hooks/userPermissions';

library.add(
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble,
);

//#endregion

export const AgentsTableAxios = () => {
  const userPermissions = useUserPermissions();
  // Config de hooks
  const [agentData, setAgentData] = useState([]);

  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [rowId, setRowId] = useState(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [businessId, setBusinessId] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [modalTShow, setModalTShow] = useState(false);
  const [modalTDeleteShow, setModalTDeleteShow] = useState(false);
  const [modalTUpdateShow, setModalTUpdateShow] = useState(false);

  const { t } = useTranslation();

  const {
    techsString,
    techContactNameString,
    techEmailString,
    techPhoneString,
    techBirthDateString,
    techStatusString,
    multDeleteString,
    addString,
    detailString,
    editString,
    logsString,
    deleteString,
    noTechsString,
    viewTutorialString,
    createdAtString,
    createdByString,
    updatedAtString,
    updatedByString,
    notesString,
    jobString,
    techEntryDateString,
  } = useTranslationHook();

  const { setIsOpen, setSteps, setCurrentStep } = useTour();

  const techsTour = useTechsTour(setModalTShow);

  const locale = useTableLocale();

  useEffect(() => {
    // Check if techsTour has not been viewed
    const hasSeenTour = localStorage.getItem('techsTourViewed');

    if (!hasSeenTour) {
      setIsOpen(true);
      setSteps(techsTour);
      setCurrentStep(0);
      // techsTour viewed
      localStorage.setItem('techsTourViewed', 'true');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setIsOpen, setSteps]);

  const restartTour = () => {
    setIsOpen(true);
    setSteps(techsTour);
    setCurrentStep(0);
    localStorage.setItem('techsTourViewed', 'false');
  };

  useEffect(() => {
    const updateTechData = () => {
      setAgentData((prevData) => {
        return prevData.map((tech) => ({
          ...tech,
          is_active: t(`${tech.is_active}`),
        }));
      });
    };
    i18next.on('languageChanged', updateTechData);

    return () => {
      i18next.off('languageChanged', updateTechData);
    };
  }, [t]);

  const endpoint = `${GlobalVariables.getURL()}listTechs`;

  const getData = async () => {
    setIsLoading(true);

    try {
      const response = await customAxios.get(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });
      const techData = response.data
        .filter((tech) => tech.id !== 1)
        .map((tech) => {
          return {
            ...tech,
            is_active: t(`${tech.is_active}`),
          };
        });
      setAgentData(techData);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const getBusinessId = async () => {
    try {
      const response = await customAxios.get(
        `${GlobalVariables.getURL()}config/businessIdentifier`,
        {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        },
      );
      if (response.data && response.data.data) {
        setBusinessId(response.data.data);
      } else {
        console.log('No businessId found in response');
      }
    } catch (error) {
      console.log('Error fetching businessId:', error);
    }
  };

  useEffect(() => {
    getData();
    getBusinessId();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // No necesitas hacer nada en este efecto.
  }, [isLoading]);

  const navigate = useNavigate();

  const manageTechDelete = (techInfo) => {
    var techId = techInfo.id;
    localStorage.setItem('techIdToDelete', techId);

    var techEmail = techInfo.email;
    var techCreatedDate = techInfo.created_at;
    var techPhone = techInfo.telefono;
    var techName = techInfo.name + ' ' + techInfo.last_name;
    localStorage.setItem('techNameToDelete', techName);
    localStorage.setItem('techEmailToDelete', techEmail);
    localStorage.setItem('techCreatedDateToDelete', techCreatedDate);
    localStorage.setItem('techPhoneToDelete', techPhone);
  };

  const [modalTMultipleDeleteShow, setModalTMultipleDeleteShow] =
    useState(false);

  const manageTechMultipleDelete = () => {
    localStorage.setItem('multipleDeleteList', rowSelectionModel);
  };

  const actionColumn = [
    {
      field: 'action',
      headerName: detailString,
      headerClassName: 'techs-datagrid-actions-tour',
      width: 160,
      renderCell: (params) => {
        return (
          <div className='cellAction techs-datagrid-actions-tour'>
            {userPermissions.includes('Update Technicals') &&
              params.row.id !== 1 && (
                <Tooltip title={editString} arrow>
                  <button
                    style={{
                      background: 'none',
                      border: 'none',
                      padding: 0,
                      marginTop: '5px',
                    }}
                    onClick={() => {
                      setModalTUpdateShow(true);
                      setRowId(params.row.id);
                    }}
                  >
                    <ModeEditOutlineOutlinedIcon
                      className='detail-icons'
                      id='update-icon'
                    />
                  </button>
                </Tooltip>
              )}
            <Tooltip title={logsString} arrow>
              <button
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  marginTop: '5px',
                }}
                onClick={() => {
                  navigate(`/tech/details/${params.row.id}`);
                }}
              >
                <VisibilityOutlinedIcon
                  className='detail-icons'
                  id='update-icon'
                />
              </button>
            </Tooltip>
            {userPermissions.includes('Delete Technicals') && (
              <Tooltip title={deleteString} arrow>
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    marginTop: '5px',
                  }}
                  onClick={() => {
                    setModalTDeleteShow(true);
                    manageTechDelete(params.row);
                  }}
                >
                  <DeleteIcon className='detail-icons' id='delete-icon' />
                </button>
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ];

  // Columnas
  const agentColumns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 70,
    },
    {
      field: 'full_name',
      headerName: techContactNameString,
      width: 250,
      renderCell: (params) => {
        var full_name = params.row.name + ' ' + params.row.last_name;
        return (
          <div>
            <span>{full_name}</span>
          </div>
        );
      },
    },
    {
      field: 'email',
      headerName: techEmailString,
      width: 180,
    },
    {
      field: 'telefono',
      headerName: techPhoneString,
      width: 160,
    },
    {
      field: 'clients',
      headerName: 'Plazas',
      width: 250,
    },
    {
      field: 'role_name',
      headerName: 'Rol',
      width: 150,
    },
    {
      field: 'fechaNacimiento',
      headerName: techBirthDateString,
      width: 160,
    },
    {
      field: 'entry_date',
      headerName: techEntryDateString,
      width: 160,
    },
    {
      field: 'is_active',
      headerName: techStatusString,
      width: 100,
      renderCell: (params) => {
        if (
          params.row.is_active === 'Activo' ||
          params.row.is_active === 'Active'
        ) {
          return (
            <div>
              <span className='statusActive'>{params.row.is_active}</span>
            </div>
          );
        } else {
          return (
            <div>
              <span className='statusInactive'>{params.row.is_active}</span>
            </div>
          );
        }
      },
      valueGetter: (params) => params.row.is_active,
    },
    {
      field: 'created_at',
      headerName: createdAtString,
      width: 150,
    },
    {
      field: 'created_by',
      headerName: createdByString,
      width: 150,
    },
    {
      field: 'updated_at',
      headerName: updatedAtString,
      width: 150,
    },
    {
      field: 'updated_by',
      headerName: updatedByString,
      width: 150,
    },
    {
      field: 'job',
      headerName: jobString,
      width: 150,
    },
    {
      field: 'notes',
      headerName: notesString,
      width: 200,
    },
    // Map through all columns and add default renderCell if not already defined
  ].map((col) =>
    col.renderCell
      ? col
      : {
          ...col,
          renderCell: (params) =>
            ['created_at', 'updated_at'].includes(col.field)
              ? formatDateDDMMYYYY(params.row[col.field])
              : params.row[col.field] || '-',
        },
  );

  return (
    <>
      <div className='datatable-btns-container'>
        <div className='dt-btn-main-container'>
          <span className='dabiWebText'> {techsString} </span>
          {userPermissions.includes('Create Tecnichals') && (
            <button
              className='add-button create-tech-tour'
              onClick={() => setModalTShow(true)}
            >
              {addString} <FontAwesomeIcon icon={faAdd} />
            </button>
          )}
          {userPermissions.includes('Delete Technicals') && (
            <button
              disabled={isButtonDisabled}
              onClick={() => {
                setModalTMultipleDeleteShow(true);
                manageTechMultipleDelete();
              }}
              className='multiple-delete-btn'
            >
              {multDeleteString}
            </button>
          )}
          {/* Mostrar el código de la empresa de manera sutil aquí */}
          <Typography
            variant='caption'
            display='block'
            color='textSecondary'
            sx={{ paddingLeft: '10px' }}
          >
            Código de la Empresa: {businessId ? businessId : 'Cargando...'}
          </Typography>
        </div>
        <Tooltip title={viewTutorialString}>
          <IconButton
            className='tour-button'
            size='medium'
            onClick={() => restartTour()}
          >
            <FontAwesomeIcon icon={faCircleInfo} />
          </IconButton>
        </Tooltip>
      </div>

      <ModalT
        show={modalTShow}
        onHide={() => setModalTShow(false)}
        getTechs={getData}
        className='create-tech-form-tour'
      />

      <ModalTMultDelete
        show={modalTMultipleDeleteShow}
        onHide={() => setModalTMultipleDeleteShow(false)}
        getTechs={getData}
      />

      <ModalTUpdate
        show={modalTUpdateShow}
        onHide={() => setModalTUpdateShow(false)}
        getTechs={getData}
        techId={rowId}
      />

      <ModalTDelete
        show={modalTDeleteShow}
        onHide={() => setModalTDeleteShow(false)}
        getTechs={getData}
      />

      <DataGridPro
        localeText={locale.components.MuiDataGrid.defaultProps.localeText}
        pagination
        loading={isLoading}
        initialState={{
          sorting: {
            sortModel: [{ field: 'id', sort: 'desc' }],
          },
          columns: {
            columnVisibilityModel: {
              id: false,
            },
          },
          pinnedColumns: { right: ['action'] },
        }}
        rows={agentData}
        columns={agentColumns.concat(actionColumn)}
        pageSize={5}
        rowsPerPageOptions={[5]}
        checkboxSelection
        disableRowSelectionOnClick
        onRowSelectionModelChange={(newRowSelectionModel) => {
          setRowSelectionModel(newRowSelectionModel);
          if (newRowSelectionModel.length >= 1) {
            setIsButtonDisabled(false);
          }
          if (newRowSelectionModel.length === 0) {
            setIsButtonDisabled(true);
          }
        }}
        rowSelectionModel={rowSelectionModel}
        slots={{
          noRowsOverlay: () => (
            <Stack height='100%' alignItems='center' justifyContent='center'>
              {noTechsString}
            </Stack>
          ),
          toolbar: GridToolbar,
        }}
        className='techs-datagrid-tour'
      />
    </>
  );
};
